import {i18n} from '@/plugins/i18n';


// const

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: false,
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'name',
        title: i18n.t('label.level_name'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'settlement_limit',
        title: i18n.t('label.settlement_limit') + ' ' + '(ریال)',
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'iban_national_id_matching',
        title: i18n.t('label.iban_national_id_matching'),
        sortable: false,
        template: row => {
            if (row.iban_national_id_matching) {
                return `<i class="fa px-1 fa-check text-success"></i>`;
            }
            return `<i class="fa px-1 fa-times text-danger"></i>`;
        },
        textAlign: 'center',
    },
    {
        field: 'phone_national_id_matching',
        title: i18n.t('label.phone_national_id_matching'),
        sortable: false,
        template: row => {
            if (row.phone_national_id_matching) {
                return `<i class="fa px-1 fa-check text-success"></i>`;
            }
            return `<i class="fa px-1 fa-times text-danger"></i>`;
        },
        textAlign: 'center',
    },
    {
        field: 'otp_authentication_condition',
        title: i18n.t('label.otp_authentication_condition'),
        sortable: false,
        template: row => {
            if (row.otp_authentication_condition) {
                return `<i class="fa px-1 fa-check text-success"></i>`;
            }
            return `<i class="fa px-1 fa-times text-danger"></i>`;
        },
        textAlign: 'center',
    }
]
